import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Global, css } from '@emotion/react';
import 'focus-visible';
import Theme from './theme';
const styles = css `
    html,
    body,
    #root {
        color: ${Theme.colors.grey90};
        height: 100%;
        min-height: -webkit-fill-available;
    }
    html {
        font-family: ${Theme.text.headingFontFamily}, sans-serif;
        box-sizing: border-box;
    }
    *,
    *:before,
    *:after {
        box-sizing: inherit;
    }

    *,
    *::after,
    *::before {
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        font-smoothing: antialiased;
    }
    .js-focus-visible .focus-visible {
        outline: none;
        box-shadow: 0 0 1px 3px #76c1ff;
        -webkit-box-shadow: 0 0 1px 3px #76c1ff; /* Blink, Chrome */
        -moz-box-shadow: 0 0 1px 3px #76c1ff; /* Firefox */
    }

    :focus-within input.focus-visible,
    .js-focus-visible :focus:not(.focus-visible) {
        outline: none;
        box-shadow: none;
    }
    :-moz-focusring,
    ::-moz-focus-inner {
        border: 0;
    }
    .ReactModalPortal {
        position: absolute;
        height: 100vh;
    }
`;
export const SafariLandscapeFullHeightHack = css `
    /* %%SAFARIHACK%% okay this is a hack to resolve Safari iOS not respecting height: 100%, and instead forcing us to do 100vh
    Keep it until this known issue gets fixed: https://developers.google.com/web/updates/2016/12/url-bar-resizing
    It works by checking for a landscape device, and the next rule (the @supports bit) is a hack that determines if it is 
    indeed Safari iOS and not Chrome on iOS. This won't work forever, but when it stops working hopefully it won't matter 
    anymore and there will be an official way to do 100% height in landscape that works on all devices/browsers.
    */
    @media (min-height: 324px) and (max-height: 500px) and (orientation: landscape) {
        @supports (background: -webkit-named-image(i)) {
            height: 100vh !important;
        }
    }
`;
const GlobalStyles = () => _jsx(Global, { styles: styles });
export default GlobalStyles;
//# sourceMappingURL=global_styles.js.map